import { AdresZoeker } from "../AdresZoeker";
import { FeatureBase } from "../base/FeatureBase";
import { CompanySearcher } from "../CompanySearcher";

export class FeatureFactory {

  private static featureMap: { [key: string]: () => FeatureBase } = {
    'bedrijvenzoeker': () => new CompanySearcher(),
    'adreszoeker': () => new AdresZoeker()
  };

  static getFeatureForField(field: Field): FeatureBase | null {
    const inputControlStyle = field.settings.inputcontrolstyle;
    const createFeatureInstance = this.featureMap[inputControlStyle];

    if (createFeatureInstance) {
      return createFeatureInstance();
    }
    return null;
  }
}